<script setup lang="ts">
/** A calm loader; under reduced motion it stays a still arc. */
</script>

<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    aria-hidden="true"
    fill="none"
    class="shrink-0 animate-spin-calm motion-reduce:animate-none"
  >
    <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-opacity=".25" stroke-width="2" />
    <path d="M14 8a6 6 0 0 0-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>
